import { configure, defineRule } from 'vee-validate';
import AllRules from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import en from '@vee-validate/i18n/dist/locale/en.json';
import ko from '@vee-validate/i18n/dist/locale/ko.json';

// Install all rules
Object.keys(AllRules).forEach(rule => {
  defineRule(rule, AllRules[rule]);
});

//custom rules

/**
 *
 * @description : 파일 사이즈 체크
 */
defineRule('filecheck', (value, _, { field }) => {
  if (!value) {
    return `${field}항목은 필수항목입니다.`;
  } else if (typeof value === 'object') {
    //MB 기준으로 계산한다. 1MB = 1024 ** 2
    const oneMb = 1024 ** 2;
    const limitMb = 5 * oneMb; //5MB

    const { size } = value;

    if (size > limitMb) {
      return `${field}항목은 5MB이하만 가능합니다.`;
    }
  }
  return true;
});

/**
 * @description : image size 체크
 */
defineRule('imageCheck', value => {
  return true;
});

/**
 * @description : 날짜 데이터 체크
 */
defineRule('multidateCheck', (value, _, { field }) => {
  if (!value[0]) {
    return `${field} 항목의 시작일자 값이 존재 하지 않습니다.`;
  }

  if (!value[1]) {
    return `${field} 항목의 종료일자 값이 존재 하지 않습니다.`;
  }

  //시작일자 > 종료일자
  if (value[0].getTime() > value[1].getTime()) {
    return `${field} 항목의 시작일자가 종료일자보다 클 수는 없습니다. `;
  }

  return true;
});

/**
 * @description : 글자 사이즈 체크
 */
defineRule('textSize', (value, [min, max], { field }) => {
  if (value.length < min || value.length > max) {
    return `${field} 항목은 4자이상 10자이하 입력이 가능합니다.`;
  }
  return true;
});

/**
 * @description : 중복확인
 */
defineRule('isDup', (_, __, ctx) => {
  const { form, field } = ctx;
  if (form.dupConfirmCode === 'N') {
    return `${field}항목의 값을 중복확인해주세요`;
  }
  return true;
});

defineRule('isDupTarget', (_, [target], ctx) => {
  const { form, field } = ctx;

  if (form[target]['codeConfirm'] === 'N') {
    return `${field}항목의 값을 중복확인해주세요`;
  }
  return true;
});

defineRule('checkBox', (value, _, { field }) => {
  if (!value || value.length === 0) {
    return `${field} 항목은 필수 항목입니다.`;
  }
  return true;
});

/**
 * @description : 체크박스 필수값 체크
 */
defineRule('checkboxCheck', (value, _, { field }) => {
  if (value.filter(item => item.isUse === 'Y').length === 0) {
    return `${field} 항목은 필수 항목입니다.`;
  }
  return true;
});

defineRule('maxLength', (value, [limit], { field }) => {
  if (value.length > limit) {
    return `${field}항목은 ${limit}자 이하만 가능합니다.`;
  }

  return true;
});

/**
 * @description : 기간 체크(기준시작일자,기준종료일자,비교시작일자 비교종료일자)
 */
defineRule('peroidCheck', (_, __, ctx) => {
  const { rule } = ctx;
  const { params } = rule;

  if (params.length === 3) {
    const standardStDt = new Date(params[0]);
    const standardEndDt = new Date(params[1]);
    const diffSplit = params[2].split('~');
    const diffStartDt = new Date(diffSplit[0]);
    const diffEndDt = new Date(diffSplit[1]);

    if (standardStDt.getTime() > diffStartDt.getTime() || standardEndDt.getTime() < diffEndDt.getTime()) {
      return `과정의 수강신청 기간이 차수 기간 내에 있는지 확인해주세요`;
    }

    return true;
  }

  return true;
});

configure({
  generateMessage: localize({
    en: {
      messages: en.messages,
    },
    ko: {
      messages: ko.messages,
    },
  }),
});
